module.exports = __webpack_public_path__ + "static/media/ambient_loop01.6add431b.mp3";